import { Link as RouterLink } from 'react-router-dom';

import {
  Container,
  Box,
  Typography,
  IconButton,
  CardMedia,
  Link,
} from '@material-ui/core';

import fb from 'assets/icons/facebook.png';
import ig from 'assets/icons/instagram.png';

import { useStyles } from './footer.styles';

export const Footer = () => {
  const classes = useStyles();

  const facebookURL = new URL(
    '/Wellnub-109247271500626',
    'https://www.facebook.com',
  );

  const instagramURL = new URL('/wellnub', 'https://www.instagram.com');

  return (
    <Box component="footer" className={classes.footer}>
      <Container className={classes.container}>
        <Box className={classes.wrapper}>
          <Typography
            variant="body2"
            color="secondary"
            className={classes.info}
          >
            Copyright &reg; Wellnub {new Date().getFullYear()}
          </Typography>
          <Link
            to="/conditions"
            component={RouterLink}
            className={classes.info}
            underline="none"
            target="_blank"
          >
            Términos y Condiciones
          </Link>
          <Link
            to="/privacy"
            component={RouterLink}
            className={classes.info}
            underline="none"
            target="_blank"
          >
            Aviso de privacidad de datos
          </Link>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="space-evenly">
          <IconButton onClick={() => window.open(facebookURL.toString())}>
            <CardMedia component="img" image={fb} className={classes.social} />
          </IconButton>
          <IconButton onClick={() => window.open(instagramURL.toString())}>
            <CardMedia component="img" image={ig} className={classes.social} />
          </IconButton>
        </Box>
      </Container>
    </Box>
  );
};
